/** @flow */
import Page from './Page';


export default Page;
export { Page };
